// extracted by mini-css-extract-plugin
module.exports = {"container":"TrainSHomeStation_container__33s2j"};